import lazyModal from 'common/module/ui/lazy-modal';
import { ModalNames } from 'common/module/ui/lazy-modal/constant-types';

export const openFacebookAccountRecoveryModal = () => {
  lazyModal.open(ModalNames.FACEBOOK_ACCOUNT_RECOVERY);
};

export const openRewindModal = () => lazyModal.open(ModalNames.REWIND_MODAL);
